<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 行政管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>社会保障信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input class="handle-input mr10"	placeholder="名称"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
							class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="170px" :rules="rules">
				<table class="table-form">
					<tr>
						<td class="table-td-first">名称</td>
						<td colspan="3"><el-input v-model="form.name" placeholder="名称"></el-input></td>
					</tr>
					<tr>
						<th>类型</th>
						<th>基数</th>
						<th>公司比列<br>（0.15表示15%，没有为0）</th>
						<th>个人比例<br>（0.08表示8%，没有为0）</th>
					</tr>
					<tr>
						<td class="table-td-first">养老保险</td>
						<td><el-input v-model="form.retirementBase" placeholder="养老保险基数"> </el-input></td>
						<td><el-input v-model="form.retirementCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.retirementPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
					<tr>
						<td class="table-td-first">医疗保险</td>
						<td><el-input v-model="form.medicalTreatmentBase" placeholder="医疗保险基数"> </el-input></td>
						<td><el-input v-model="form.medicalTreatmentCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.medicalTreatmentPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
					<tr>
						<td class="table-td-first">失业保险</td>
						<td><el-input v-model="form.unemploymentBase" placeholder="失业保险基数"> </el-input></td>
						<td><el-input v-model="form.unemploymentCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.unemploymentPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
					<tr>
						<td class="table-td-first">工伤保险</td>
						<td><el-input v-model="form.industrialInjuryBase" placeholder="工伤保险基数"> </el-input></td>
						<td><el-input v-model="form.industrialInjuryCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.industrialInjuryPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
					<tr>
						<td class="table-td-first">生育保险</td>
						<td><el-input v-model="form.birthBase" placeholder="生育保险基数"> </el-input></td>
						<td><el-input v-model="form.birthCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.birthPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
					<tr>
						<td class="table-td-first">公积金</td>
						<td><el-input v-model="form.accumulationFundBase" placeholder="公积金基数"> </el-input></td>
						<td><el-input v-model="form.accumulationFundCompanyRatio" placeholder="公司比例"> </el-input></td>
						<td><el-input v-model="form.accumulationFundPersonalRatio" placeholder="个人比例"> </el-input></td>
					</tr>
				</table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchSocialSecurityData, saveSocialSecurity, deleteSocialSecurity, getSocialSecurity, getUserKV } from '../../../api/index';
export default {
    name: 'social-security',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
			showVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
                name: [{ required: true, message: '请输入待办事项', trigger: 'blur' }],
				handler: [{ required: true, message: '请选择指派对象', trigger: 'blur' }],
				expirationTime: [{ required: true, message: '请选择最晚处理时间', trigger: 'blur' }]
            },
			statusKV:[{"key":1,"value":"待办"},{"key":2,"value":"处理中"},{"key":3,"value":"已处理"}],
			userKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("social-security");
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchSocialSecurityData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSocialSecurity([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
			getSocialSecurity(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveSocialSecurity(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.dealVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.table-form {
	padding:20px;
	border:1px solid #EBEEF5;
	border-collapse: collapse;
	width:100%;
}
.table-form th {
	padding:15px;
	border:1px solid #EBEEF5;
	background:#f5f7fa;
}
.table-form td {
	padding:10px;
	border:1px solid #EBEEF5
}
.table-td-first {
	background:#f5f7fa;
	width:150px;
	text-align:center;
}
</style>
